const getCookie = (name) => {
  const cookies = document.cookie.split('; ');
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=');
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
};

// Función para establecer una cookie con nombre, valor y opciones
const setCookie = (name, value, options = {}) => {
  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  if (options.expires && options.expires instanceof Date) {
    cookieString += `; expires=${options.expires.toUTCString()}`;
  }

  if (options.path) {
    cookieString += `; path=${options.path}`;
  }

  if (options.domain) {
    cookieString += `; domain=${options.domain}`;
  }

  if (options.secure) {
    cookieString += '; secure';
  }

  document.cookie = cookieString;
};

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    (this.classList.contains('warranty-widget-enabled') && this.validateWarrantyItems())
    this.verifyGamificationTiers()
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement)
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    /* Team-SB */
    document.dispatchEvent(new CustomEvent('featuredSection:init'));
    document.dispatchEvent(new CustomEvent('lpPagesCartCount:init'));
    if(parsedState?.item_count > 0) {
      this.classList.contains('is-empty') && this.classList.remove('is-empty');
      this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
      parsedState?.items.forEach((item) => {
        this.productId = item.id;
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });
      })
    } else {
      if(parsedState.quantity > 0){this.classList.remove('is-empty')}else{this.classList.add('is-empty')}
      this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });
    }
    
    (this.classList.contains('warranty-widget-enabled') && this.validateWarrantyItems());
    
    this.updateCustomBubbleCount(parsedState)
    this.verifyGamificationTiers();
    
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: document.querySelector('cart-drawer').dataset.sectionId,
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  updateCustomBubbleCount(parsedState){
    if(document.querySelector('.cart_link_bubble_num_new') && parsedState.sections['cart-icon-bubble']){
      let aux = document.createElement('div');
      aux.innerHTML = parsedState.sections['cart-icon-bubble'];
      (aux.querySelector('.cart-count-bubble > span') && (document.querySelector('.cart_link_bubble_num_new').innerHTML = aux.querySelector('.cart-count-bubble > span')?.innerHTML))
      return parseInt(aux.querySelector('.cart-count-bubble > span')?.innerHTML) || false;
    }else{
      return false;
    }
  }

  verifyGamificationTiers(){
    let currentQuantity = parseInt(this.querySelector('.clutch-cart-gamification')?.dataset.currentQuantity),
    pastQuantity = parseInt(getCookie('currentCartQty')) || 0;

    this.querySelectorAll('.reached').forEach(element=>{
      element.classList.remove('reached')
    })

    if(currentQuantity > pastQuantity) {
      let elements = this.querySelectorAll('[data-reached="true"]');
      let last = elements[elements.length - 1];
      last?.classList.add('reached')
    }
    setCookie('currentCartQty', currentQuantity)

  }

  validateWarrantyItems() {
    if (!window.ClutchWarrantySync) return;
    return window.ClutchWarrantySync.reconcile({
      intent: window.pendingPdpWarrantyAttach || window.addingWarranty ? 'attach' : 'reconcile',
      trackAttach: !!window.pendingPdpWarrantyAttach
    });
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: document.querySelector('cart-drawer').dataset.sectionId,
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class ContentUpsell extends HTMLElement {
  constructor() {
      super();
      this.component = this;

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      this.scrollNext = this.scrollNext.bind(this);
      this.scrollPrev = this.scrollPrev.bind(this);

      this.querySelector('.next').addEventListener('click', this.scrollNext);
      this.querySelector('.prev').addEventListener('click', this.scrollPrev);

      this.addEventListener('scroll', this.handleScroll.bind(this));
      
      this.handleScroll()

      this.querySelectorAll('.add').forEach(element=>{
          element.addEventListener('click', this.addFromUpsell.bind(this, element))
      })
  }

  scrollNext() {
      const container = this;
      const product = container.querySelector('.product');
      const productWidth = product?.offsetWidth || 0;
      const scrollableWidth = container.scrollWidth - container.clientWidth;
      if (( scrollableWidth - (container.scrollLeft + productWidth)) < (productWidth / 2) ){
          container.scrollLeft = scrollableWidth
      }else{
          container.scrollLeft += productWidth;
      }

      setTimeout(() => {
          this.handleScroll();
      }, 500);
  }

  scrollPrev() {
      const container = this;
      const product = container.querySelector('.product');
      const productWidth = product?.offsetWidth || 0;
      const scrollableWidth = container.scrollWidth - container.clientWidth;
      if(container.scrollLeft-productWidth <  (productWidth / 2)){
          container.scrollLeft = 0;
      }else{
          container.scrollLeft -= productWidth;
      }

      setTimeout(() => {
          this.handleScroll();
      }, 500);
  }

  handleScroll(){
      const container = this;
      const product = container.querySelector('.product');
      const productWidth = product?.offsetWidth || 0;
      const scrollableWidth = container.scrollWidth - container.clientWidth;

      const nextButton = container.querySelector('.next');
      const prevButton = container.querySelector('.prev');

      if (container.scrollLeft >= scrollableWidth) {
          nextButton.disabled = true;
          if (prevButton.disabled) prevButton.disabled = false;
      } else if (container.scrollLeft === 0) {
          prevButton.disabled = true;
          if (nextButton.disabled) nextButton.disabled = false;
      } else {
          if (prevButton.disabled) prevButton.disabled = false;
          if (nextButton.disabled) nextButton.disabled = false;
      }

  }

  addFromUpsell(element) {
    const addProduct = async (productId) => {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      try {
        // First, get the current cart data
        const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
        const cartData = await cartResponse.json();

        // Find the current quantity of the product
        const currentItem = cartData.items.find(item => item.id == productId);
        const currentQty = currentItem ? currentItem.quantity : 0;

        // Increment the quantity
        const newQty = currentQty + 1;

        // Prepare form data for updating the cart
        const formData = new FormData();
        formData.append('form_type', "cart");
        formData.append(`updates[${productId}]`, newQty);

        if (this.cart) {
            formData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;

        // Send the update request
        const updateResponse = await fetch(window.Shopify.routes.root + 'cart/update.js', config);
        const updatedCart = await updateResponse.json();

        if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
        }
        this.cart.renderContents(updatedCart);

      } catch (error) {
        console.error(error);
      }
    }

    addProduct(element.dataset.id);
  }
}

customElements.define('content-upsell', ContentUpsell);

class WelcomeBackSavedCart extends CartDrawer {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close(evt));
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', (evt) => this.close(evt));
    this.querySelector('.go-to-cart').addEventListener('click', (evt) => this.close(evt));
    
    // No llamamos a setHeaderCartIconAccessibility ni a verifyGamificationTiers
    (this.classList.contains('warranty-widget-enabled') && this.validateWarrantyItems());

    this.init();

  }

  init(){
    // Verificamos la cookie _wbsc
    const wbscCookie = getCookie('_wbsc');
    if (!wbscCookie && !this.classList.contains('is-empty')) {
      this.open();
    }
  }

  // Eliminamos el método setHeaderCartIconAccessibility
  setHeaderCartIconAccessibility() {
    // Este método se redefine pero no hace nada.
  }

  // Sobrescribimos el método open para no llamar a verifyGamificationTiers
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement)
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  // Sobrescribimos el método close para establecer la cookie _wbsc
  close(evt) {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    
    // Establecemos la cookie _wbsc como true por 1 día
    const expires = new Date();
    expires.setDate(expires.getDate() + 1);
    setCookie('_wbsc', 'true', { expires, path: '/' });

    // Verificamos si el evento proviene de un elemento con la clase go-to-cart
    if (evt && evt.target && evt.target.classList.contains('go-to-cart')) {
      setTimeout(() => {
        document.querySelector('cart-drawer').open();
      }, 0);
    }
  }

  // Sobrescribimos el método renderContents para no llamar a verifyGamificationTiers
  renderContents(parsedState) {
    document.dispatchEvent(new CustomEvent('featuredSection:init'));
    document.dispatchEvent(new CustomEvent('lpPagesCartCount:init'));
    if(parsedState?.item_count > 0) {
      this.classList.contains('is-empty') && this.classList.remove('is-empty');
      this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
      parsedState?.items.forEach((item) => {
        this.productId = item.id;
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });
      })
    } else {
      if(parsedState.quantity > 0){this.classList.remove('is-empty')}else{this.classList.add('is-empty')}
      this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });
    }
    
    (this.classList.contains('warranty-widget-enabled') && this.validateWarrantyItems());
    
    this.updateCustomBubbleCount(parsedState);
    
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }
}

customElements.define('welcome-back-saved-cart', WelcomeBackSavedCart);